export default "__VITE_ASSET__PrXmPKFB__"